// extracted by mini-css-extract-plugin
export default {"not-found":"tKAiC","btn":"th1aU"};